module.exports = __webpack_public_path__ + "img/power-standby.22b3952e.svg";